export const menuData = [
  { title: 'À propos', link: '/about' },
  { title: 'Nos réalisations', link: '/realisations' },
  { title: 'Clôtures', link: '/clotures' },
  { title: 'Portails et Automatismes', link: '/portail' }
];
